import { Collection } from 'core/model';
import { observable } from 'mobx';
import type DeviceModel from 'app/stores/device/DeviceModel';

export class DeviceSyslogsCollection extends Collection {
  @observable.ref
  device: DeviceModel;

  constructor(device: DeviceModel) {
    super();
    this.device = device;
    this.requestStatus = 'awaitingRequest';
  }

  get url() {
    return `/api/ui/devices/${this.device.id}/syslog/query`;
  }

  get fetchMethod() {
    return 'post';
  }
}
